var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0071b9;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-256 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.684,7.907H14.462a1.787,1.787,0,0,0-1.785,1.785V23.976a1.788,1.788,0,0,0,1.785,1.785H25.684a1.788,1.788,0,0,0,1.785-1.785V9.693A1.788,1.788,0,0,0,25.684,7.907Zm-.255,15.813H14.717V9.948H25.429Zm-17.6-5.1H11.47v2.04H7.575A1.788,1.788,0,0,1,5.79,18.875V4.591A1.787,1.787,0,0,1,7.575,2.806H18.8a1.788,1.788,0,0,1,1.785,1.785v2.2h-2.04V4.846H7.83V18.619Z",
    transform: "translate(251.211 463.194)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(256 465)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy);
export default __webpack_public_path__ + "static/media/icons-copy.6b8f5f9d.svg";
export { ForwardRef as ReactComponent };